// src/Dashboard/pages/user/Inscription/components/DrawerShell.jsx

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FaTimes } from "react-icons/fa";

export default function DrawerShell({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  children,
  footer,
  width = "max-w-3xl",
}) {
  useEffect(() => {
    if (!isOpen) return;

    const previous = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";

    const onEsc = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onEsc);

    return () => {
      document.documentElement.style.overflow = previous;
      window.removeEventListener("keydown", onEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999]">
      <div
        className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <aside
        className={`absolute right-0 top-0 flex h-full w-full ${width} flex-col overflow-hidden border-l border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-slate-950`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-5 text-white sm:px-6">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <div className="flex items-center gap-3">
                {icon && (
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/20">
                    {icon}
                  </span>
                )}

                <div className="min-w-0">
                  <h2 className="truncate text-lg font-bold sm:text-xl">
                    {title}
                  </h2>

                  {subtitle && (
                    <p className="mt-1 text-sm leading-5 text-white/85">
                      {subtitle}
                    </p>
                  )}
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white/15 text-white transition hover:bg-white/25"
              title="Fermer"
              aria-label="Fermer"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4 sm:p-6">
          {children}
        </div>

        {footer && (
          <div className="border-t border-slate-200 bg-white/95 p-4 backdrop-blur dark:border-slate-800 dark:bg-slate-950/95">
            {footer}
          </div>
        )}
      </aside>
    </div>,
    document.body
  );
}